import React, { useContext, useEffect, useState } from 'react'
import { getConfiguration, getMybetsPage, getQueryStringVariable, loadSessionToken } from '../../data/utils'
import { UserContext } from '../../data/betslip/UserConf';
import { getMyBets } from '../../data/fetchMyBets';
import { openPopup } from '../../data/sport-utils';
import { systemCode, xs_languageCode } from '../..';
import { getLabel } from '../../InitData';

export const CounterMyBets = () => {
  const conf = getConfiguration();
  const userContext = useContext(UserContext);
  const user = userContext.getUser();
  const dateFrom = getQueryStringVariable('dateFrom')
  const dateTo = getQueryStringVariable('dateTo')
  const [dataMyBets, setDataMyBets] = useState({ open: [] })

  function openMyBets() {
    const mybetsPage = getMybetsPage(false);
    const  url = `${process.env.PUBLIC_URL}${mybetsPage}`;
    const popupWidth = systemCode === 'WILLIAMHILL' ? 750 : 500;
    openPopup(`${url}?token=${loadSessionToken()}&language=${xs_languageCode}&systemCode=${systemCode}`, getLabel('general.mybets'), popupWidth, 800);
  }

  useEffect(() => {
    getMyBets(userContext.sessionToken, dateFrom, dateTo, (parsedData) => {
      setDataMyBets(parsedData)
    })
  }, [])

  return (
    <>
      <div className="mybets-button-container">
        <div id="mybetsButton" className="bottone pointer counterMyBets" onClick={openMyBets} />
        {
          dataMyBets.open.length > 0 &&
          <span id="myBets-number" className="badge bordo-rotondo bg-colore-1 bianco">{dataMyBets.open.length}</span>
        }
      </div>
    </>
  )
}
